import { EnglishArabicDTO, FileDTO } from "bnsights-control-library"
export class PublicHolidayModel {
  ID: number;
  IDEncrypted: string;
  SysName: string;
  Name: EnglishArabicDTO = new EnglishArabicDTO();
  Description: EnglishArabicDTO = new EnglishArabicDTO();
  IsActive: boolean;
  Day: number;
  Month: number;
  CountryID: number;
  CountryName: string ;
Date:string;
ImageFileID?:number;
ImageFileDTO:FileDTO;

}
